export const GETDATAREQUEST = "GETDATAREQUEST";
export const GETDATASUCCESS = "GETDATASUCCESS";
export const GETDATAREJECTED = "GETDATAREJECTED";

export const POSTDATA_REQUEST ="POSTDATA_REQUEST";
export const POSTDATA_SUCCESS ="POSTDATA_SUCCESS";
export const POSTDATA_REJECTED ="POSTDATA_REJECTED";

export const UPDATEDATA_REQUEST ="UPDATEDATA_REQUEST";
export const UPDATEDATA_SUCCESS ="UPDATEDATA_SUCCESS";
export const UPDATEDATA_REJECTED ="UPDATEDATA_REJECTED";

export const DELETEDATA_REQUEST ="DELETEDATA_REQUEST";
export const DELETEDATA_SUCCESS ="DELETEDATA_SUCCESS";
export const DELETEDATA_REJECTED ="DELETEDATA_REJECTED";

